import * as React from 'react';
import * as styles from './styles.scss';
import { IconButton } from '@fluentui/react/lib/Button';
import type { IIconProps } from '@fluentui/react/lib/Icon';
import { observer } from 'mobx-react-lite';
import {
    moreButtonText,
    deleteMocaProjectText,
    renameMocaProjectText,
} from './ChangeOutlookSpaceButton.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';
import type { TimeStreamProject } from 'owa-timestream-store';
import { useConfirmAndDeleteOutlookSpace } from '../index';

const moreButton: IIconProps = { iconName: ControlIcons.More };
const dropdownMenuProps = {
    className: styles.assetEllipsisMenuButton,
};

export default observer(function ChangeOutlookSpaceButton({
    project,
    onRename,
}: {
    project: TimeStreamProject;
    onRename: () => void;
}) {
    const title = loc(moreButtonText);

    const menuProps = {
        items: [
            {
                key: 'edit',
                text: loc(renameMocaProjectText),
                iconProps: { iconName: 'Rename' },
                onClick: onRename,
            },
            {
                key: 'delete',
                text: loc(deleteMocaProjectText),
                iconProps: { iconName: ControlIcons.Delete },
                onClick: useConfirmAndDeleteOutlookSpace(project),
            },
        ],
        shouldFocusOnMount: false,
    };

    return (
        <IconButton
            tabIndex={0}
            aria-hidden={false}
            role="button"
            data-is-focusable={true}
            iconProps={moreButton}
            menuProps={menuProps}
            menuIconProps={dropdownMenuProps}
            title={title}
        />
    );
});
